import maintainRequest from "@/maintain/utils/maintainRequest";

export default function maintenanceManChangeDeviceQRCode
    (code, deviceId) {
    return maintainRequest.get(`/device/deviceQRCode/maintenanceManChangeDeviceQRCode/${code}/${deviceId}`)
}
